/* TROPICO consent boxes: terms (required) and marketing (optional), both pre-checked. Injected above the checkout button in the cart drawer and on the cart page. */
(function () {
  'use strict';
  if (window.__tpcConsent) return;
  window.__tpcConsent = true;

  var KEY = 'tpc_consent_v1';
  var TERMS_URL = '/policies/terms-of-service';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var BTN_SEL = '#CartDrawer-Checkout, #CartDrawer .cart__checkout-button, #checkout';
  var state = { terms: true, marketing: true };
  var going = false;
  try {
    var saved = JSON.parse(sessionStorage.getItem(KEY) || 'null');
    if (saved && typeof saved === 'object') {
      state.terms = saved.terms !== false;
      state.marketing = saved.marketing !== false;
    }
  } catch (e) {}

  function save() {
    try { sessionStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {}
  }

  var CSS = [
    '.tpc-consent{margin:12px 0 10px;padding:10px 12px;border:1px solid rgba(0,0,0,.12);border-radius:10px;background:rgba(0,0,0,.03);font-size:1.3rem;line-height:1.5;text-align:right}',
    '.tpc-consent__row{display:flex;align-items:flex-start;gap:10px;margin:0 0 8px;cursor:pointer}',
    '.tpc-consent__row input{flex:0 0 auto;width:18px;height:18px;margin:2px 0 0;accent-color:#0b7a4b;cursor:pointer}',
    '.tpc-consent__row a{text-decoration:underline;color:inherit}',
    '.tpc-consent__error{margin:8px 0 0;color:#c0392b;font-weight:700}',
    '.tpc-blocked{opacity:.55}',
    '.is-empty .tpc-consent{display:none}'
  ].join('');

  var HTML =
    `<label class='tpc-consent__row'><input type='checkbox' data-tpc-consent-terms checked><span>קראתי ואני מאשר/ת את <a href='${TERMS_URL}' target='_blank' rel='noopener'>תקנון האתר</a></span></label>` +
    `<label class='tpc-consent__row'><input type='checkbox' data-tpc-consent-marketing checked><span>אני מאשר/ת קבלת הודעות פרסומיות, הטבות והנחות מ-TROPICO במייל ובהודעות טקסט. אפשר להסיר את ההסכמה בכל עת.</span></label>` +
    `<p class='tpc-consent__error' data-tpc-consent-error role='alert' hidden>כדי להמשיך לתשלום צריך לאשר את תקנון האתר.</p>`;

  function showError(on) {
    document.querySelectorAll('[data-tpc-consent-error]').forEach(function (el) { el.hidden = !on; });
  }

  function apply() {
    document.querySelectorAll('[data-tpc-consent-terms]').forEach(function (el) { el.checked = state.terms; });
    document.querySelectorAll('[data-tpc-consent-marketing]').forEach(function (el) { el.checked = state.marketing; });
    document.querySelectorAll(BTN_SEL).forEach(function (b) {
      b.classList.toggle('tpc-blocked', !state.terms);
      b.setAttribute('aria-disabled', state.terms ? 'false' : 'true');
    });
    if (state.terms) showError(false);
  }

  function mount() {
    document.querySelectorAll('.cart__ctas').forEach(function (ctas) {
      var prev = ctas.previousElementSibling;
      if (prev && prev.hasAttribute('data-tpc-consent')) return;
      var box = document.createElement('div');
      box.className = 'tpc-consent';
      box.setAttribute('data-tpc-consent', '');
      box.innerHTML = HTML;
      ctas.parentNode.insertBefore(box, ctas);
    });
    apply();
  }

  /* Save the answers on the cart so they show up on the order as additional details */
  function syncAttributes() {
    return fetch(ROOT + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: {
        terms_accepted: state.terms ? 'yes' : 'no',
        marketing_consent: state.marketing ? 'yes' : 'no',
        consent_time: new Date().toISOString()
      } })
    }).catch(function () {});
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches) return;
    if (t.matches('[data-tpc-consent-terms]')) {
      state.terms = t.checked;
    } else if (t.matches('[data-tpc-consent-marketing]')) {
      state.marketing = t.checked;
    } else {
      return;
    }
    save();
    apply();
    syncAttributes();
  });

  /* Gate on window in the capture phase: it runs before every other click handler on the page
     (including tropico-cart.js, which used to send the customer straight to /checkout). */
  window.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest(BTN_SEL);
    if (!btn || btn.disabled) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (!state.terms) {
      showError(true);
      var scope = btn.closest('.drawer__footer, .cart__blocks') || document;
      var box = scope.querySelector('[data-tpc-consent-terms]');
      if (box && box.scrollIntoView) box.scrollIntoView({ block: 'center', behavior: 'smooth' });
      return;
    }
    if (going) return;
    going = true;
    btn.setAttribute('aria-busy', 'true');
    syncAttributes().then(function () {
      var form = btn.form;
      if (!btn.closest('#CartDrawer') && form && form.requestSubmit) {
        form.requestSubmit(btn);
      } else {
        window.location.assign(ROOT + 'checkout');
      }
      setTimeout(function () { going = false; btn.removeAttribute('aria-busy'); }, 6000);
    });
  }, true);

  /* Also block submitting the cart form with the Enter key */
  window.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || (f.id !== 'CartDrawer-Form' && f.id !== 'cart')) return;
    var sub = e.submitter;
    if (sub && sub.name && sub.name !== 'checkout') return;
    if (!state.terms) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showError(true);
    }
  }, true);

  function boot() {
    var st = document.createElement('style');
    st.textContent = CSS;
    document.head.appendChild(st);
    mount();
    var scheduled = false;
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () { scheduled = false; mount(); });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
